<template>
    <div class="hero">
        <div class="intro-text">
            <h1 class="hero-title">Supercharge Your Website</h1>
            <span class="hero-subtitle">Get blazing fast web hosting for your business</span>
        </div>

        <domain-search-component></domain-search-component>
        <support-items-component></support-items-component>

        <scroll-down-component></scroll-down-component>
    </div>
</template>

<script>
    import DomainSearchComponent from "./DomainSearchComponent";
    import SupportItemsComponent from "./SupportItemsComponent";
    import ScrollDownComponent from "./ScrollDownComponent";

    export default {
        name: "HomeHeroComponent",
        components: {ScrollDownComponent, SupportItemsComponent, DomainSearchComponent}
    }
</script>

<style lang="scss" scoped>

    .sp-bottom {
        margin-bottom:  3.2rem
    }
    .hero {
        padding: 100px 20px;
        height: calc(100vh - 119px);
        max-height: 600px;
    }

    .intro-text {
        margin-left: 10px;
        margin-bottom: 25px;
        font-family: "ProximaRegular", "Nunito", sans-serif;
        font-weight: bold;
    }

    h1.hero-title {
        margin-bottom: 2px;
        font-weight: bolder;
        color: #222;
    }

    .hero-subtitle {
        color: #666;
    }

    .hero {
        position: relative;
    }

    .hero:after {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        height: 100%;
        width: 100%;
        background: url('/img/server-lineart.svg') no-repeat right;
        background-size: contain;
        z-index: -10;
        opacity: .2;
        filter: blur(3px);
        max-height: 400px;
    }

    .hero:before {
        display: block;
        position: absolute;
        top: -40px;
        left: 0;
        background: url(/img/super_hero.png);
        content: "";
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-position: 70% 20%;
        transform: rotateZ(210deg) translateY(30px) scale(-1);
        background-size: contain;
        z-index: -9;
        filter: saturate(0.5);
        /*animation: home-superhero ease-in-out 2s;*/
        animation-iteration-count: infinite;
        animation-direction: alternate-reverse;
        transform-origin: 50% 50%;
        max-height: 400px;
    }

    @media screen and (max-width: 768px) {
        .hero {
            display: block;
            position: relative;
            height: auto;
            padding-bottom: 0;

            &:before {
                display: none;
            }
        }
    }

    /*scaleX(-1)*/
    @keyframes home-superhero {
        0% {
            transform: translate(0, -10px) rotateZ(20deg);
        }
        100% {
            transform: translate(0, 10px) rotateZ(20deg);
        }
    }
</style>